import {Component, EventEmitter} from '@angular/core';
import {ModalComponent} from '../modal-service.service';

import {NlrTooltipDirective} from '../../../../common/directive/tooltip/nlr-tooltip-directive';

@Component({
    selector: 'nlr-attachments-modal',
    imports: [NlrTooltipDirective],
    templateUrl: './field-record-lodgement-errors-modal.component.html',
    styleUrls: ['../modal.scss', './field-record-lodgement-errors-modal.component.scss']
})
export class FieldRecordLodgementErrorModalComponent implements ModalComponent {
    modalClosed: EventEmitter<string> = new EventEmitter<string>();
    modalSize: string = 'modal-lg';
    title: string = undefined;
    lodgementErrorText: string = undefined;
    lodgementErrorList: any[] = undefined;

    close() {
        this.modalClosed.emit('close');
    }
}
